import { Event, SetDimension, SetUserId } from "../../tracking";
import {
  LOADING_USER, 
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED, 
  SET_USER
} from '../types';
  
  const initialState = {
    authenticated: false,
    loading: false,
    credentials: {},
    likes: [],
    notifications: [],
    group: "",
    groupLink: ""
  };
  
  export default function(state = initialState, action) {
    switch (action.type) {
      case SET_AUTHENTICATED:
        const { source, userId } = action.payload
        SetUserId(userId);
        SetDimension("dimension1", state.group); // TODO: add a way to set dimension of user (or add this to SET_USER?)
        SetDimension("dimension2", userId);
        Event("Authentication", source, userId);
        return {
          ...state,
          authenticated: true
        };
      case SET_UNAUTHENTICATED:
        return initialState;
      case SET_USER:
        return {
          ...state,
          authenticated: true,
          loading: false,
          ...action.payload
        };
      case LOADING_USER:
        return {
          ...state,
          loading: true
        };
      default:
        return state;
    }
  }